import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
}
